import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(!_vm.hideAll)?_c('Toolbar'):_vm._e(),(!_vm.hideDrawer)?_c('Drawer'):_vm._e(),_c(VMain,{staticClass:"main",class:{ 'ma-0': _vm.hideDrawer }},[_c('router-view')],1),(_vm.companyVisible)?_c('Company',{attrs:{"visible":_vm.companyVisible},on:{"setDialogVisible":_vm.actionCompany}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }